export let detailsAboutSlide_en = {
    About_us_title: "About us",
    About_us_content: "Megamix Group is the largest Russian producer of premix and compound feed for all species of livestock and poultry and one of leading producers in Europe. The company's share in the global animal feed market is 1%. 32% of compound feed produced in Russia is based on Megamix premix.",
    MEGAMIX_Group: "MEGAMIX Group",
    Other_Russian_manufacturers: "Other Russian manufacturers",
    Foreign_companies: "Foreign companies",
    others: "Others",
}

export let detailsAboutSlide_ru = {
    About_us_title: "О компании",
    About_us_content: "Группа компаний «Мегамикс» — крупнейший в России и один из крупнейших в Европе производитель премиксов и комбикормов для всех видов сельскохозяйственных животных и птиц. Доля компании на мировом рынке кормов для животных – 1%. 32% комбикормов в РФ производятся на основе премиксов «Мегамикс».",
    MEGAMIX_Group: "ГК МЕГАМИКС",
    Other_Russian_manufacturers: "Другие российские производители",
    Foreign_companies: "Зарубежные компании",
    others: "Кто-то еще",
}

export let detailsAboutSlide_cn = {
    About_us_title: "关于公司",
    About_us_content: "Megamix集团是俄罗斯最大的预混合饲料和饲料生产商之一，也是欧洲最大的生产商之一。公司在全球动物饲料市场的份额为1%。32%的俄罗斯饲料是基于Megamix的预混合饲料。",
    MEGAMIX_Group: "Megamix集团",
    Other_Russian_manufacturers: "其他俄罗斯制造商",
    Foreign_companies: "外国公司",
    others: "其他人",
}